import { render, staticRenderFns } from "./AddPrizeDialog.vue?vue&type=template&id=e84a721e&scoped=true&"
import script from "./AddPrizeDialog.vue?vue&type=script&lang=js&"
export * from "./AddPrizeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84a721e",
  null
  
)

export default component.exports